import './style.scss';
import React, {useEffect, useState} from "react";
import EditProfile from "./editProfile";
import ViewProfile from "./viewProfile";
import {useDispatch, useSelector} from "react-redux";
import {
  clearChangePasswordErrors,
  clearChangePasswordSuccess,
  clearSaveMyProfileErrors,
  clearUserFormErrors,
  fetchMyProfile,
  saveMyProfile
} from "../../actions/users";

import Alert from "../../components/common/alert";
import {MESSAGES} from "../../constants";
import UserPermissions from "../../components/userPermissions";

export const route = 'my-profile';

const MyProfile = () => {
  const [profileEdit, setProfileEdit] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const errors = useSelector((state) => state.users.userFormErrors);
  const changePasswordSuccess = useSelector((state) => state.users.changePasswordSuccess);
  const dispatch = useDispatch();

  const myUser = useSelector((state) => state.session.currentUser);

  useEffect(() => {
      dispatch(fetchMyProfile(myUser));
  }, [myUser, dispatch]);

  const myProfile = useSelector((state) => state.users.myProfile);
  const saveMyProfileErrors = useSelector((state) => state.users.saveMyProfileErrors);

  const onSubmitAction = (profileForm, myProfile) => {
    dispatch(saveMyProfile(profileForm, myProfile, myUser));
    setFormSubmitted(true);
  }

  const onDismissAlert = () => {
    dispatch(clearSaveMyProfileErrors());
  }

  const dismissChangePasswordAlert = () => {
    dispatch(clearChangePasswordSuccess());
  }

  const gotoEditAction = () => {
    dispatch(clearChangePasswordErrors());
    setProfileEdit(true);
  }

  if (formSubmitted && !errors) {
    setFormSubmitted(false);
    setProfileEdit(false);
  }

  return (
    <div className='main-content'>
      <div className='my-profile-header'>My Profile</div>
      <div className='my-profile-alerts'>
        {(saveMyProfileErrors) && <Alert messageType='error' onDismiss={onDismissAlert}>{saveMyProfileErrors}</Alert>}
        {(changePasswordSuccess) && <Alert messageType='success' onDismiss={dismissChangePasswordAlert}>{MESSAGES.USERS.changePasswordSuccess}</Alert>}
      </div>
      <div className='my-profile-container'>
        <div className='my-info-content'>
          {(profileEdit)
              ? <EditProfile errors={errors} myProfile={myProfile} onSubmitAction={onSubmitAction} onCancelAction={() => {dispatch(clearUserFormErrors()); setProfileEdit(false)}}/>
              : <ViewProfile myProfile={myProfile} gotoEditAction={() => {gotoEditAction()}}/>}
        </div>
      </div>
      {myProfile && (
        <div className='user-permissions-container'>
          <UserPermissions userProfile={myProfile} districts={myProfile?.districtList || []} hideEditButton={true}/>
        </div>
      )}
    </div>
  )
}

export default MyProfile;
